import {
  UPLOAD_CLASS_COVER_USE_CASE,
  UploadClassCoverUseCase,
  FILE_STORAGE_V2_REPOSITORY,
  IFileStorageV2Repository,
  SAVE_FILE_USE_CASE,
  CREATE_QUESTION_ANSWER_FILE_STORAGE_USE_CASE,
  CREATE_QUESTION_FILE_STORAGE_USE_CASE,
  CREATE_FORM_THUMBNAIL_USE_CASE,
  SaveFileUseCase,
  CreateQuestionAnswerFileUseCase,
  CreateQuestionFileUseCase,
  CreateFormThumbnailUseCase,
  FILE_STORAGE_REPOSITORY,
  IFileStorageRepository,
  DELETE_FILE_USE_CASE,
  DeleteFileUseCase,
  IExternalFileStorageRepository,
  EXTERNAL_FILE_STORAGE_REPOSITORY,
} from '@module/file-storage';

export const fileStorageUseCaseProviders = [
  {
    provide: UPLOAD_CLASS_COVER_USE_CASE,
    useFactory: (files: IFileStorageV2Repository, externalFiles: IExternalFileStorageRepository) =>
      new UploadClassCoverUseCase(files, externalFiles),
    inject: [FILE_STORAGE_V2_REPOSITORY, EXTERNAL_FILE_STORAGE_REPOSITORY],
  },
  {
    provide: CREATE_QUESTION_FILE_STORAGE_USE_CASE,
    useFactory: (
      fileStorageRepository: IFileStorageRepository,
      externalFileStorageRepository: IExternalFileStorageRepository,
    ) => {
      return new CreateQuestionFileUseCase(fileStorageRepository, externalFileStorageRepository);
    },
    inject: [FILE_STORAGE_REPOSITORY, EXTERNAL_FILE_STORAGE_REPOSITORY],
  },
  {
    provide: CREATE_QUESTION_ANSWER_FILE_STORAGE_USE_CASE,
    useFactory: (
      fileStorageRepository: IFileStorageRepository,
      externalFileStorageRepository: IExternalFileStorageRepository,
    ) => {
      return new CreateQuestionAnswerFileUseCase(
        fileStorageRepository,
        externalFileStorageRepository,
      );
    },
    inject: [FILE_STORAGE_REPOSITORY, EXTERNAL_FILE_STORAGE_REPOSITORY],
  },
  {
    provide: SAVE_FILE_USE_CASE,
    useFactory: (fileStorageRepository: IFileStorageRepository) => {
      return new SaveFileUseCase(fileStorageRepository);
    },
    inject: [FILE_STORAGE_REPOSITORY],
  },
  {
    provide: DELETE_FILE_USE_CASE,
    useFactory: (fileStorageRepository: IFileStorageRepository) => {
      return new DeleteFileUseCase(fileStorageRepository);
    },
    inject: [FILE_STORAGE_REPOSITORY],
  },
  {
    provide: CREATE_FORM_THUMBNAIL_USE_CASE,
    useFactory: (
      fileStorageRepository: IFileStorageRepository,
      externalFileStorageRepository: IExternalFileStorageRepository,
    ) => {
      return new CreateFormThumbnailUseCase(fileStorageRepository, externalFileStorageRepository);
    },
    inject: [FILE_STORAGE_REPOSITORY, EXTERNAL_FILE_STORAGE_REPOSITORY],
  },
];
